// import defaultSettings from '@/settings'


const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || ''
const state = {
    // image_base_url: 'https://dev.nmgheli.com:8910/images',
    image_base_url: '../images',
}
const mutations = {}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

